import React, { useState } from 'react';
import './SchemaApprovalModal.css';

/**
 * Schema Approval Modal - Human-in-the-loop approval for generated schemas
 */
const SchemaApprovalModal = ({ 
  schema, 
  fields = [], 
  message, 
  onApprove, 
  onReject, 
  onClose 
}) => {
  const [feedback, setFeedback] = useState('');
  const [showRejectForm, setShowRejectForm] = useState(false);

  const handleReject = () => {
    if (showRejectForm) {
      onReject(feedback);
    } else {
      setShowRejectForm(true);
    }
  };

  const handleApprove = () => {
    onApprove();
  };

  return (
    <div className="schema-modal-overlay" onClick={onClose}>
      <div className="schema-modal" onClick={e => e.stopPropagation()}>
        <div className="schema-modal-header">
          <h2>Review Generated Schema</h2>
          <button className="schema-modal-close" onClick={onClose}>×</button>
        </div>

        <div className="schema-modal-body">
          {message && (
            <div className="schema-modal-message">
              {message}
            </div>
          )}

          {fields && fields.length > 0 && (
            <div className="schema-modal-fields">
              <h3>Extracted Fields</h3>
              <table className="schema-fields-table">
                <thead>
                  <tr>
                    <th>Field Name</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {fields.map((field, idx) => (
                    <tr key={idx}>
                      <td className="field-name">{field.name || field.field_name}</td>
                      <td className="field-type">{field.type || field.field_type}</td>
                      <td className="field-desc">{field.description || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {schema && (
            <div className="schema-modal-json">
              <h3>JSON Schema</h3>
              <pre>{JSON.stringify(schema, null, 2)}</pre>
            </div>
          )}

          {showRejectForm && (
            <div className="schema-modal-feedback">
              <label htmlFor="feedback">What changes would you like?</label>
              <textarea
                id="feedback"
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                placeholder="Describe what fields to add, remove, or modify..."
                rows={3}
              />
            </div>
          )}
        </div>

        <div className="schema-modal-footer">
          <button 
            className="schema-modal-btn reject"
            onClick={handleReject}
          >
            {showRejectForm ? 'Submit Changes' : 'Request Changes'}
          </button>
          <button 
            className="schema-modal-btn approve"
            onClick={handleApprove}
          >
            Approve Schema
          </button>
        </div>
      </div>
    </div>
  );
};

export default SchemaApprovalModal;

